import { FC } from 'react'
import { ReactComponent as MyDepositIcon } from './img/deposit.svg'
import IconWrapper, { IconWrapperProps } from './IconWrapper'

type DepositIconProps = IconWrapperProps

export const DepositIcon: FC<DepositIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyDepositIcon />
    </IconWrapper>
  )
}
